import React from 'react'

import TVHomepageDealGroup from '../../tv-homepage-deal-group'

const BroadbandDealGroupWrapper = ({ name, type, count, ctaLabel, ctaLink }) => {
  return <TVHomepageDealGroup name={name} type={type} count={count} ctaLabel={ctaLabel} ctaLink={ctaLink} />
}

export default BroadbandDealGroupWrapper
